import { PrimaryButton, SecondaryButton } from 'src/shared/design-system/Buttons';
import { More } from 'src/shared/design-system/Icon';
import { OverflowMenu } from 'src/shared/design-system/OverflowMenu';
import styled from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';
import { POST_TEXT } from '../../consts';
import { DarkenContainer } from '../styles';

export const Container = styled(DarkenContainer)`
  padding: 0 ${Spacing.SINGLE};
  background: ${Colors.WHITE};
  ${Mixins.Border.setBottomSide(Border.Radius.S)}
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: ${Spacing.SINGLE};

  &:empty {
    padding-bottom: 0;
  }
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: ${Spacing.HALF};
  padding-bottom: ${Spacing.SINGLE};
`;

export const DeleteContainer = styled(Container)`
  padding-top: ${Spacing.SINGLE};
  margin-bottom: ${Spacing.SINGLE};

  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}
  & ${ButtonWrapper} {
    padding: ${Spacing.SINGLE} 0 0 0;
  }
`;

export const MenuIcon = styled(More)`
  transform: rotateZ(90deg);
`;

export const MenuContainer = styled.div`
  color: ${Colors.GRAY_DARK_10};
  display: flex;
  justify-content: flex-end;

  &:only-child {
    flex: 1 1 auto;
  }

  & button {
    height: auto;
    width: auto;
  }
`;

export const Menu = styled(OverflowMenu).attrs(() => ({
  isVerticalIcon: true,
}))``;

export const CancelButton = styled(SecondaryButton.S.GRAY).attrs(() => ({
  children: POST_TEXT.FOOTER.BUTTONS.CANCEL,
}))``;

export const SaveButton = styled(PrimaryButton.S.RED).attrs(() => ({
  children: POST_TEXT.FOOTER.BUTTONS.SAVE,
}))``;

export const DeleteButton = styled(PrimaryButton.S.RED).attrs(() => ({
  children: POST_TEXT.FOOTER.BUTTONS.DELETE,
}))``;
